module.exports = __webpack_public_path__ + "static/media/hey-kitchen-backend-orders.0aa271c8.png";